module.exports = __webpack_public_path__ + "img/5.a99352a0.png";